/** @type {Array<{ value: string, label: string }>} */
export const LISTEN_FOR_OPTIONS = [
  { value: 'off', label: 'Off' },
  { value: 'hey-sia', label: '"Hey Sia"' },
  { value: 'keyboard', label: 'Keyboard shortcut only' },
]

/** @type {Array<{ value: string, label: string }>} */
export const KEYBOARD_SHORTCUT_OPTIONS = [
  { value: 'cmd-s', label: 'Press ⌘ S' },
  { value: 'cmd-space', label: 'Press ⌘ Space' },
  { value: 'fn-s', label: 'Press fn S' },
  { value: 'off', label: 'Off' },
]

/** @type {Array<{ value: string, label: string }>} */
export const ASSISTANT_LANGUAGE_OPTIONS = [
  { value: 'en-gb', label: 'English (United Kingdom)' },
  { value: 'en-us', label: 'English (United States)' },
  { value: 'en-in', label: 'English (India)' },
  { value: 'es-es', label: 'Spanish (Spain)' },
  { value: 'fr-fr', label: 'French (France)' },
]

/** @type {Array<{ value: string, label: string }>} */
export const ASSISTANT_RESPONSE_OPTIONS = [
  { value: 'silent', label: 'Prefer silent responses' },
  { value: 'spoken', label: 'Prefer spoken responses' },
  { value: 'automatic', label: 'Automatic' },
]
